import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import './index.css';
import * as serviceWorker from "./serviceWorker";
import { AuthProvider } from './context/AuthContext';

ReactDOM.render(
    <AuthProvider>
        <App />
    </AuthProvider>,
    document.getElementById('root')
);

serviceWorker.register();